import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
    this.setState({ info });
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, fontFamily: "system-ui, sans-serif", color: "#0b1020" }} data-testid="error-boundary">
          <h1 style={{ fontSize: 20, fontWeight: 700 }}>Something went wrong</h1>
          <pre style={{ whiteSpace: "pre-wrap", background: "#fef2f2", color: "#991b1b", padding: 12, borderRadius: 8, marginTop: 12, fontSize: 12 }}>
            {String(this.state.error?.stack || this.state.error)}
          </pre>
          {this.state.info && (
            <pre style={{ whiteSpace: "pre-wrap", background: "#f3f4f6", padding: 12, borderRadius: 8, marginTop: 12, fontSize: 11 }}>
              {this.state.info.componentStack}
            </pre>
          )}
          <button onClick={() => window.location.reload()} style={{ marginTop: 12, padding: "8px 16px", background: "#0E9F6E", color: "white", border: 0, borderRadius: 6, cursor: "pointer" }}>
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
